import WorkspaceDB from './db'

export default class WebmangoBrowserWorkspace extends WorkspaceDB {
  getMDSSDB () {
    return this.workspaceDB.hoodieApi().withIdPrefix('mdss')
  }
}



// WEBPACK FOOTER //
// ../webmango-api/workspace/browser.js